export const CHECKOUT_URL = 'https://metodo-para-padres-de-futbolistas-latam.impultienda.ar/checkout';
export const stats = [{
  value: "5 +2",
  label: "Módulos y Bonos"
}, {
  value: '+250',
  label: 'Páginas en PDF'
}, {
  value: '100%',
  label: 'Material digital'
}, {
  value: "∞",
  label: 'Acceso de por vida'
}];
export const pagePreviews = [{
  src: 'https://cdn.magicpatterns.com/uploads/gWGopN68TyuJYPVD7rjr46/WhatsApp_Image_2026-09-10_at_5.05.30_PM.jpg',
  alt: 'Cómo distinguir agentes certificados por FIFA de intermediarios sin licencia.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eR6E4Tdf6gDE1zQMVF6M6L/WhatsApp_Image_2026-09-10_at_5.05.31_PM_(1).jpg',
  alt: 'Los 8 componentes que debe tener un contrato de formación válido.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/w4VNBW9TGK62q64hpt7o8q/WhatsApp_Image_2026-09-10_at_5.05.31_PM_(3).jpg',
  alt: 'Los 3 macronutrientes con gramos por kilo y fórmula de referencia rápida.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bm6EjyTgEd8K5WcWSJxuBp/WhatsApp_Image_2026-09-10_at_5.05.31_PM_(2).jpg',
  alt: 'Las 4 fases de la nutrición en fútbol y el ajuste por tipo de día.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/m9uSnPpz7KYGkfUsunC4Ei/WhatsApp_Image_2026-09-10_at_5.05.30_PM_(1).jpg',
  alt: 'Tabla de las 5 presiones psicológicas más sutiles y cómo responder a cada una.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wmyjuZz9JnjmggfbeumhUt/WhatsApp_Image_2026-09-10_at_5.05.30_PM_(2).jpg',
  alt: 'Capítulo de psicología del entorno: presión, presencia y manejo del rechazo.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/chf2EK1jHHuhkTwKJxUsXA/WhatsApp_Image_2026-09-10_at_5.05.31_PM.jpg',
  alt: 'Checklist de acción inmediata con los 5 pasos para la primera semana.'
}];
export const heroTestimonials = [{
  quote: 'No entendía nada de divisiones menores: ni cómo funcionan los clubes, ni los permisos, ni los derechos deportivos. Cuando una academia de Medellín nos hizo una oferta, ya sabía qué preguntar, qué pedir por escrito y qué no aceptar.',
  name: 'Andrés M.',
  role: 'Papá de jugador Sub-16 · Medellín, Antioquia'
}, {
  quote: 'Nos llamó un supuesto representante y no sabíamos cómo confirmar si era de verdad. El método nos dio un orden claro para revisar todo y también para acompañar a mi hijo sin meterle más presión.',
  name: 'Carolina R.',
  role: 'Mamá de jugador Sub-15 · Bogotá, Cundinamarca'
}];
export const problems = ['Su hijo o hija casi no tiene minutos y usted no sabe cómo hablarlo con el club, ni cuándo conviene buscar otra institución.', 'Aparecen "veedores" o representantes y usted no tiene cómo confirmar si están registrados ante la FCF y la FIFA o si solo están engañando a su familia.', 'Le ponen al frente un contrato o una carta de compromiso y no sabe qué cláusulas revisar antes de firmar.', 'Les llega una "oportunidad" en Europa, México o Estados Unidos y no distingue si es real o si es una estafa.', 'No sabe qué derechos tiene un menor de edad en el fútbol formativo según el reglamento de la FCF, Difútbol y FIFA.', 'Quiere acompañar la carrera de su hijo o hija, pero no sabe por dónde empezar ni qué decisiones tomar primero.'];
export const chapters = [{
  number: '01',
  title: 'Cómo funciona el fútbol formativo bajo el marco de FIFA',
  description: 'Entienda quién es quién: clubes profesionales, canteras y academias afiliadas, la federación nacional y las ligas locales, los veedores y los agentes licenciados. Cómo se organiza el camino formativo según la estructura que FIFA define para el fútbol base —con ejemplos aplicados a Colombia— y cuál es el rol real de padres y madres en cada etapa, de los 8 a los 18 años.',
  tags: ['Estructura FIFA', 'Clubes y canteras', 'Etapas del jugador', 'Rol de la familia']
}, {
  number: '02',
  title: 'Legalidad: contratos, representantes y todo por escrito',
  description: 'El Reglamento sobre el Estatuto y la Transferencia de Jugadores de FIFA (RSTP) y las normas de agentes explicados en lenguaje sencillo, junto con cómo se aplican a través de la federación nacional. Cómo detectar veedores falsos, pruebas de mentiras y representantes sin licencia, qué cláusulas leer con calma, por qué los derechos deportivos y cualquier acuerdo deben quedar por escrito, y en qué momento conviene consultar a un abogado especializado en derecho deportivo.',
  tags: ['FIFA / RSTP', 'Cláusulas clave', 'Representantes sin licencia', 'Todo por escrito']
}, {
  number: '03',
  title: 'Visibilidad: que el talento se vea y llegue a quien decide',
  description: 'Cómo construir visibilidad real: video de jugadas bien editado, hoja de vida deportiva, uso responsable de redes, calendario de torneos y pruebas, y contactos verificados. Incluye cómo preparar la exposición ante veedores de clubes locales y cómo evaluar rutas internacionales —Europa, la MLS o el college en Estados Unidos— dentro de las reglas de FIFA para menores, paso a paso.',
  tags: ['Video y hoja de vida', 'Torneos y pruebas', 'Contactos verificados', 'Estrategia con veedores']
}, {
  number: '04',
  title: 'Biología y mente: rendimiento sostenible sin quiebres',
  description: 'Maduración biológica, carga de entrenamiento, descanso, nutrición y prevención de lesiones a nivel educativo. Además, cómo acompañar emocionalmente sin convertirse en una fuente de presión, y un semáforo de alertas para saber cuándo frenar, cuándo insistir y cuándo pedir ayuda profesional.',
  tags: ['Maduración y carga', 'Nutrición y descanso', 'Manejo emocional', 'Semáforo de alertas']
}];
export const bonuses = [{
  number: 'Bono 01',
  title: 'EL MANUAL DEL AGENTE Y EL CONTRATO PERFECTO',
  description: 'Plantillas y lista de chequeo para revisar contratos y cartas de compromiso: qué preguntar, qué soportes pedir, qué alertas detectar y cómo documentar todo antes de firmar.',
  originalPrice: 'US$ 13'
}, {
  number: 'Bono 02',
  title: 'PRUEBAS, BECAS Y OPORTUNIDADES INTERNACIONALES',
  description: 'Pasos prácticos para grabar, seleccionar y estructurar videos de forma profesional, además de una estructura de hoja de vida deportiva para un contacto efectivo.',
  originalPrice: 'US$ 13'
}];
export const offerChecklist = ['5 módulos completos', 'Más de 250 páginas en PDF', 'El Triángulo de Blindaje: Legalidad, Biología y Visibilidad', 'El manual del agente y el contrato perfecto', 'Pruebas, becas y oportunidades internacionales', 'Acceso inmediato de por vida'];
export const testimonials = [{
  initials: 'AM',
  color: '#1d4ed8',
  quote: 'Una academia nos hizo una oferta y por primera vez la pude evaluar con criterio: qué pedir por escrito, qué confirmar con el club y qué dejar en pausa.',
  name: 'Andrés Mosquera',
  role: 'Papá de jugador Sub-16 · Medellín, Antioquia'
}, {
  initials: 'CR',
  color: '#b45309',
  quote: 'Nos llamó un representante que no pudimos confirmar por ningún lado. Con las listas del método le paramos a tiempo y nos evitamos un compromiso que no nos servía.',
  name: 'Carolina Restrepo',
  role: 'Mamá de jugador Sub-15 · Bogotá, Cundinamarca'
}, {
  initials: 'PS',
  color: '#15803d',
  quote: 'Antes de firmar, revisamos el documento con las preguntas del módulo de contratos y llevamos las dudas a un abogado. Firmamos con mucha más claridad.',
  name: 'Paola Salazar',
  role: 'Mamá de jugador de divisiones menores · Cali, Valle del Cauca'
}, {
  initials: 'JQ',
  color: '#7e22ce',
  quote: 'Armamos el video de jugadas y la hoja de vida deportiva tal cual la guía, y organizamos los torneos y las pruebas del año. Hoy tenemos una estrategia, ya no andamos a la deriva.',
  name: 'Julián Quintero',
  role: 'Papá de jugador Sub-17 · Barranquilla, Atlántico'
}, {
  initials: 'MV',
  color: '#be123c',
  quote: 'Nos salió la posibilidad de una prueba en el exterior y no sabíamos ni qué papeles pedir. El método nos ordenó los tiempos, los requisitos y las preguntas correctas.',
  name: 'Mónica Villegas',
  role: 'Mamá de jugadora Sub-18 · Bucaramanga, Santander'
}, {
  initials: 'GC',
  color: '#0f766e',
  quote: 'Mi hijo venía muy cargado entre el colegio y los entrenamientos. Con el semáforo de alertas supimos cuándo bajarle y hablamos con el cuerpo técnico sin pelear.',
  name: 'Gerardo Cuadrado',
  role: 'Papá de jugador Sub-14 · Cartagena, Bolívar'
}];
export const faqs = [{
  question: '¿Sirve si apenas estoy entendiendo el mundo de las divisiones menores?',
  answer: 'Sí, está pensado exactamente para eso. Explica todo desde cero, con lenguaje claro, sin tecnicismos y con ejemplos del fútbol base colombiano.'
}, {
  question: '¿Para qué categorías o edades sirve?',
  answer: 'Está orientado a papás y mamás de jugadores desde las categorías infantiles hasta las Sub-17 y Sub-20, y la firma del primer contrato profesional.'
}, {
  question: '¿Aplica en Colombia?',
  answer: 'Sí. El material está adaptado al contexto colombiano: clubes de la Liga BetPlay y el Torneo BetPlay, canteras, ligas departamentales, Difútbol y el reglamento de la FCF, junto con las reglas FIFA que aplican a menores. Como los procedimientos cambian y se actualizan, el método le indica siempre verificar con el club y con la federación antes de firmar.'
}, {
  question: '¿Es un producto físico o digital?',
  answer: '100% digital en PDF. No hay envíos. Lo puede leer desde cualquier dispositivo.'
}, {
  question: '¿Cómo recibo mi compra?',
  answer: 'Inmediatamente después del pago recibe un correo con el enlace de descarga.'
}, {
  question: '¿Tengo que pagar todos los meses?',
  answer: 'No. Es un pago único con acceso de por vida.'
}, {
  question: '¿Qué pasa si no estoy satisfecho?',
  answer: 'Tiene 7 días de garantía. Escriba a solucionesoinformacion@gmail.com.'
}, {
  question: '¿En qué se diferencia de buscar información gratis en internet?',
  answer: 'Lo que hay en internet está disperso, muchas veces desactualizado y casi nunca aplica al fútbol base de Colombia. Este método está organizado, ordenado por etapas y listo para usar justo cuando llega una decisión.'
}, {
  question: '¿Esto reemplaza a un abogado?',
  answer: 'No. Este material es educativo y no reemplaza la asesoría de un abogado especializado en derecho deportivo. Le ayuda a entender el proceso, hacer mejores preguntas y saber cuándo consultar con un profesional especializado antes de firmar.'
}, {
  question: '¿Garantiza que mi hijo o hija llegue a ser profesional?',
  answer: 'No, y desconfíe de quien lo prometa. Lo que ofrece es más claridad, mejores decisiones, menos riesgo y más control de la familia sobre el proceso.'
}];
export const comparisonRows = [{
  situation: 'Entender cómo funcionan las divisiones menores',
  without: 'Puro rumor y datos sueltos de la tribuna',
  with: 'Un mapa claro de clubes, canteras, FCF y agentes'
}, {
  situation: 'Oferta de una academia o club',
  without: 'Acepta sin saber qué está cediendo',
  with: 'Sabe qué preguntar y qué pedir por escrito'
}, {
  situation: 'Lo llama un representante',
  without: 'No tiene cómo confirmar si está registrado',
  with: 'Lista de verificación paso a paso lista para usar'
}, {
  situation: 'Antes de firmar un contrato o una carta',
  without: 'Firma sin entender las cláusulas',
  with: 'Revisa los puntos críticos y consulta a tiempo'
}, {
  situation: 'Invitación a una prueba en el exterior',
  without: 'No distingue una oportunidad real de una estafa',
  with: 'Criterios claros para evaluarla con calma'
}, {
  situation: 'Visibilidad ante veedores',
  without: 'Sin video, sin hoja de vida deportiva, sin plan',
  with: 'Video, hoja de vida y calendario de pruebas listos'
}, {
  situation: 'Presión y desgaste emocional',
  without: 'La familia mete más presión sin darse cuenta',
  with: 'Sabe cómo acompañar sin presionar'
}];
